import Http from '../http'

export default {
  getDevCount () { // 在线率查询
    return Http.post('/online/devStatus.do')
  },
  getAlarmType () { // 显示的权限查询
    return Http.post('/user/authorityList.do')
  },
  getAlarmTypeCount (params) { // 当日报警总数查询
    return Http.post('/index/alarmDaily.do', params)
  },
  getAlarmTypesCount (params) { // 当日所有报警总数查询
    return Http.post('/index/alarmsDaily.do', params)
  },
  updateAlarmType (params) { // 实时监控——设置报警显示的类型
    return Http.post('/user/updateAuthority.do', params)
  },
  // 新首页-大数据接口
  getBigData (params) {
    return Http.post('/bigData/index.do', params)
  },
  // 主动安全实时监控
  // ADAS
  getADAS () {
    return Http.post('/activeSafety/ADAS.do')
  },
  // activeSafety
  getActiveSafety () {
    return Http.post('/activeSafety/activeSafety.do')
  },
  // DSM
  getDSM () {
    return Http.post('/activeSafety/DSM.do')
  },
  // 固件首页
  firmwareDevSum () {
    return Http.post('/firmware/devSum.do')
  },
  firmwareProcessSum () {
    return Http.post('/firmware/processSum.do')
  },
  firmwareAllAlarm () {
    return Http.post('/firmware/allAlarm.do')
  },
  traceAnalyze () {
    return Http.post('/firmware/traceAnalyze.do')
  },
  alarm24Hour () {
    return Http.post('/firmware/alarm24Hour.do')
  },
  // 24小时上下客
  tendencyChart () {
    return Http.post('/taxi24/tendencyChart.do')
  },
  heatMap () {
    return Http.post('/taxi24/heatMap.do')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/home.js